import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import {
  ProductSelectorType,
  SkeletonLine,
} from '~/techstyle-shared/react-components';

import useMaxSwatchesToRender from '../../utils/useMaxSwatchesToRender';

function getBackgroundUrl({ backgroundUrl }) {
  return css`
    background-image: ${`url("${backgroundUrl}")`};
  `;
}

const PrimarySwatchRadioButton = styled.div`
  ${({ theme }) => theme.gridCellStyles.gridSwatchInputStyle}
  ${getBackgroundUrl};
  border: 2px solid
    ${({ theme }) => theme.colors.gridPrimarySwatchRadioButtonBorder};
  box-shadow: inset 0 0 0 3px ${({ theme }) => theme.colors.palette.white};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const SwatchSkeleton = styled(SkeletonLine)`
  ${({ theme }) => theme.gridCellStyles.gridSwatchInputStyle}
  border: 2px solid ${({ theme }) =>
    theme.colors.gridSwatchesLoadingSkeletonBorder};
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.gridSwatchesLoadingSkeletonBg15} 0%,
    ${({ theme }) => theme.colors.gridSwatchesLoadingSkeletonBg25} 50%,
    ${({ theme }) => theme.colors.gridSwatchesLoadingSkeletonBg15} 100%
  );
  background-size: 400% 400%;

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const LoadingSwatchesContainer = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 4px;
`;

const SwatchItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 4px;
  padding-left: 0px;
`;

const SwatchesLoadingSkeleton = ({ primarySwatchUrl }) => {
  // num of swatches to render, including primary swatch and loading skeletons
  const maxSwatchesToRender = useMaxSwatchesToRender();
  // fine to use index as key since we are not modifying the SwatchSkeleton's
  const swatchSkeletons = Array(maxSwatchesToRender - 1)
    .fill(true)
    .map((_, i) => (
      <SwatchItem key={i}>
        <SwatchSkeleton />
      </SwatchItem>
    ));
  return (
    <LoadingSwatchesContainer>
      <SwatchItem>
        <PrimarySwatchRadioButton
          backgroundUrl={primarySwatchUrl}
          selectorType={ProductSelectorType.SWATCH}
        />
      </SwatchItem>
      {swatchSkeletons}
    </LoadingSwatchesContainer>
  );
};

SwatchesLoadingSkeleton.propTypes = {
  primarySwatchUrl: PropTypes.string,
};

SwatchesLoadingSkeleton.displayName = 'SwatchesLoadingSkeleton';

export default SwatchesLoadingSkeleton;
